import "./Login.css";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import loginimg from '../assets/images/login-img.png'
import loginlogo from '../assets/images/login-logo.png'
import Footer from "../components/Footer";
import { fetchUserAppAPI } from "../utils/api";

function Login() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1); // 1 = Enter Mobile, 2 = Enter OTP/Signup
  const [userExist, setUserExist] = useState(1);
  const [sentOtp, setSentOtp] = useState("");
  
  // Registration fields for new users
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccessMsg("");

    try {
      const response = await fetchUserAppAPI("login-otp", {
        method: "POST",
        body: JSON.stringify({ user_mobile: mobile }),
      });

      if (response && response.status === 200) {
        setSentOtp(response.result);
        setUserExist(response.user_exist);
        setStep(2);
        setSuccessMsg(response.msg || `OTP sent successfully.`);
      } else {
        setError(response.msg || "Failed to send OTP. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyAndLogin = async (e) => {
    e.preventDefault();
    if (otp !== String(sentOtp)) {
      setError("Incorrect OTP. Please enter the valid OTP.");
      return;
    }

    if (userExist === 0 && (!firstName.trim() || !lastName.trim() || !email.trim())) {
      setError("Please fill in all registration fields.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const bodyPayload = {
        user_mobile: mobile,
      };

      if (userExist === 0) {
        bodyPayload.user_first_name = firstName;
        bodyPayload.user_last_name = lastName;
        bodyPayload.user_email = email;
        bodyPayload.user_device_token = "web_client_token";
      }

      const response = await fetchUserAppAPI("login", {
        method: "POST",
        body: JSON.stringify(bodyPayload),
      });

      if (response && response.status === 200 && response.result) {
        // Store user info in localStorage
        localStorage.setItem("user", JSON.stringify(response.result));
        setSuccessMsg("Logged in successfully!");
        // Redirect to dashboard
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } else {
        setError(response.msg || "Login failed. Please try again.");
      }
    } catch (err) {
      setError("An error occurred during login. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="login-container">
        <div className="container">
          <div className="loginouter">
            <div className="login_left">
              <div className="login_left_container">
                <img src={loginimg} alt="login-img"/>
                <h2>Safe, Fast & Secure Login</h2>
                <p>Experience hassle-free access to your healthcare dashboard with secure OTP verification and protected patient data.</p>
              </div>
            </div>
            <div className="login_right">
              <div className="login_right_container">
                <img src={loginlogo} alt="login-logo"/>
                <h2>Log In </h2>
                <p>
                  {step === 1 
                    ? "Enter your Mobile number and we’ll send you a one time password" 
                    : userExist === 0 
                      ? "Create your account to complete registration" 
                      : `Enter the OTP sent on +91-${mobile}`
                  }
                </p>

                {error && <div className="alert alert-danger py-2">{error}</div>}
                {successMsg && <div className="alert alert-success py-2">{successMsg}</div>}

                {/* Developer Helper for Local OTP Testing */}
                {step === 2 && sentOtp && (
                  <div className="alert alert-warning py-1 small">
                    <strong>Developer Mode OTP:</strong> {sentOtp}
                  </div>
                )}

                <div className="login_form">
                  {step === 1 ? (
                    <form className="login-form" onSubmit={handleSendOtp}>
                      <div className="form-group mb-3">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter your mobile number"
                          maxLength="10"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                          required
                          disabled={loading}
                        />
                      </div>

                      <button type="submit" className="otp-btn form_submit_btn" disabled={loading}>
                        {loading ? "Sending..." : "Send OTP"}
                      </button>
                    </form>
                  ) : (
                    <form className="login-form" onSubmit={handleVerifyAndLogin}>
                      {userExist === 0 && (
                        <>
                          <div className="form-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="First Name"
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              required
                              disabled={loading}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Last Name"
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              required
                              disabled={loading}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email Address"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              disabled={loading}
                            />
                          </div>
                        </>
                      )}

                      <div className="form-group mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter 4-Digit OTP"
                          maxLength="4"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                          required
                          disabled={loading}
                        />
                      </div>

                      <div className="d-flex gap-2">
                        <button 
                          type="button" 
                          className="btn btn-secondary flex-fill" 
                          onClick={() => { setStep(1); setError(""); setSuccessMsg(""); }}
                          disabled={loading}
                        >
                          Back
                        </button>
                        <button type="submit" className="otp-btn form_submit_btn flex-fill" disabled={loading}>
                          {loading ? "Verifying..." : "Verify & Login"}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
                <p className="policy-pera">By continuing, you agree with our <span> <Link to="/privacy-policy">Privacy Policy </Link></span> and <span> <Link to="/terms-and-condition">Terms & Conditions</Link></span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}

export default Login;